import API from './api.js'

export default {
    async getLanguages(language) {
        let result = { code: 0, data: { ui: null, analyses: null } }

        let response = await this.getLanguagesUI(language)
        if (response.code === 0)
            result.data.ui = response.data
        else
            result.code = 1

        response = await this.getLanguagesAnalyses(language)
        if (response.code === 0)
            result.data.analyses = response.data
        else
            result.code = 1

        return result
    },

    async getLanguagesUI(language) {
        try {
            let response = await API.HTTPS.get('/settings/languages/ui/' + language)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async getLanguagesAnalyses(language) {
        try {
            let response = await API.HTTPS.get('/settings/languages/analyses/' + language)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async getLanguagesEventCategories(language) {
        try {
            let response = await API.HTTPS.get('/settings/languages/eventscategories/' + language)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getRegions() {
        try {
            let response = await API.HTTPS.get('/settings/enums/regions')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getViscosityClasses() {
        try {
            let response = await API.HTTPS.get('/settings/enums/viscosityclasses')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getOilTypes(lang) {
        try {
            let response = await API.HTTPS.get('/settings/enums/oiltypes/' + lang)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getDeliveryPlaces() {
        try {
            let response = await API.HTTPS.get('/settings/enums/deliveryplaces')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    }
}